/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
//material
import { Link } from '@insticator/insticator-ui'; // iui-material
import DataLastUpdated from 'material/callout/datalastupdated/datalastupdated_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reporthelpers/reporthelpers_styles';



/* ========== ~~~~~~~~~~ REPORT HELPERS ~~~~~~~~~~ ========== */
const ReportHelpers = props => (
    <div className={`reporthelpers ${props.classes.reporthelpers}`}>
        <Link type={`internal`} behavior={`back`} name={`backtoreports`} text={`Back to all reports`} color={`primary`} action={`dashboard/reports`} icon={`hand-point-left`} />
        <DataLastUpdated />
    </div>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportHelpers);
